export default function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.52827 3.52864C3.78862 3.26829 4.21073 3.26829 4.47108 3.52864L7.99967 7.05723L11.5283 3.52864C11.7886 3.26829 12.2107 3.26829 12.4711 3.52864C12.7314 3.78899 12.7314 4.2111 12.4711 4.47145L8.94248 8.00004L12.4711 11.5286C12.7314 11.789 12.7314 12.2111 12.4711 12.4714C12.2107 12.7318 11.7886 12.7318 11.5283 12.4714L7.99967 8.94285L4.47108 12.4714C4.21073 12.7318 3.78862 12.7318 3.52827 12.4714C3.26792 12.2111 3.26792 11.789 3.52827 11.5286L7.05687 8.00004L3.52827 4.47145C3.26792 4.2111 3.26792 3.78899 3.52827 3.52864Z"
        fill="white"
      />
    </svg>
  );
}
